import { Icon, RenderWhen } from "../../../../../components";
import RiskScoreScale from "../../RiskScoreScale";
import styles from "./risk-score.module.scss";

type Props = {
  classification: string;
  factor: number;
  onClick?: () => void;
};

const RiskScore = ({ classification, factor, onClick }: Props) => (
  <div data-testid="risk-score" className={styles.risk_score_wrapper}>
    <RenderWhen
      condition={classification !== "unknown"}
      fallback={
        <span
          className={styles.risk_score_empty}
          data-testid="risk_score_no_classification"
        >
          No Classification
        </span>
      }
    >
      <span
        data-testid="risk-score-value"
        className={`${styles.risk_score_value} ${styles[classification]}`}
      >
        {factor}
      </span>
      <div className={styles.risk_score_scale_wrapper} onClick={onClick}>
        <RiskScoreScale classification={classification} factor={factor} />
        <Icon
          className={styles.risk_score_help_icon}
          name="help"
          data-testid="risk_score_tooltip_trigger"
        />
      </div>
    </RenderWhen>
  </div>
);

export default RiskScore;
